import request from "../axios-instance";

export const fuzzIxd = async (
  ixdFile: File,
  dsdFile?: File,
  seed?: number,
): Promise<{ blob: Blob; filename: string }> => {
  const formData = new FormData();
  formData.append("ixd_file", ixdFile);
  if (dsdFile) {
    formData.append("dsd_file", dsdFile);
  }

  const response = await request.post("/v1/fuzz", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob",
    params: seed != null ? { seed } : undefined,
  });

  const disposition = response.headers["content-disposition"] ?? "";
  const filenameMatch = disposition.match(/filename\*=UTF-8''(.+)/);
  const filename = filenameMatch
    ? decodeURIComponent(filenameMatch[1])
    : `fuzzed_${ixdFile.name.replace(/\.ixd$/, "")}.zip`;

  return { blob: response.data, filename };
};
